module.exports = __webpack_public_path__ + "img/ctrl-qft-stub-up-1.bef793c0.svg";